package com.trevorwiebe.timesheet.core.presentation.common

import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.toComposeImageBitmap
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import org.jetbrains.skia.EncodedImageFormat
import org.jetbrains.skia.Image as SkiaImage
import org.jetbrains.skia.Surface

actual fun ByteArray.toImageBitmap(): ImageBitmap? =
    SkiaImage.makeFromEncoded(this).toComposeImageBitmap()

actual suspend fun ByteArray.rotateImageBytes(degrees: Int): ByteArray =
    withContext(Dispatchers.Default) {
        val image = SkiaImage.makeFromEncoded(this@rotateImageBytes)
        val swapped = degrees % 180 != 0
        val newW = if (swapped) image.height else image.width
        val newH = if (swapped) image.width else image.height
        val surface = Surface.makeRasterN32Premul(newW, newH)
        surface.canvas.apply {
            translate(newW / 2f, newH / 2f)
            rotate(degrees.toFloat())
            drawImage(image, -image.width / 2f, -image.height / 2f)
        }
        surface.makeImageSnapshot()
            .encodeToData(EncodedImageFormat.JPEG, 85)
            ?.bytes ?: this@rotateImageBytes
    }
